<template>
  <NavigationComponent>
    <Standardfolie title="App.vue">
      <v-expansion-panels dark accordion flat>
        <v-expansion-panel>
          <v-expansion-panel-header v-slot="{ open }">
            <v-fade-transition leave-absolute>
              <span v-if="!open">&lt;template&gt;...&lt;/template&gt;</span>
            </v-fade-transition>
            <v-fade-transition leave-absolute>
              <span v-if="open">hier wird mit HTML das Aussehen definiert</span>
            </v-fade-transition>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <VCode
              content="&lt;template&gt;
  &lt;v-app&gt;
    &lt;NavComponent&gt;&lt;/NavComponent&gt;
    &lt;v-content&gt;
      &lt;router-view&gt;&lt;/router-view&gt;
    &lt;/v-content&gt;
  &lt;/v-app&gt;
&lt;/template&gt;"
            ></VCode>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header v-slot="{ open }">
            <v-fade-transition leave-absolute>
              <span v-if="!open">&lt;script&gt;...&lt;/script&gt;</span>
            </v-fade-transition>
            <v-fade-transition leave-absolute>
              <span v-if="open">hier wird die Logik festgelegt</span>
            </v-fade-transition>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <VCode
              content='&lt;script&gt;
  import NavComponent from "@/components/NavComponent"
  export default {
    name: "App",

    components: { NavComponent },

    data: () =&gt; ({}),

    computed: {
    },

    props: {},

    methods: {}
  };
&lt;/script&gt;'
            ></VCode>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header v-slot="{ open }">
            <v-fade-transition leave-absolute>
              <span v-if="!open">&lt;style scoped&gt;...&lt;/style&gt;</span>
            </v-fade-transition>
            <v-fade-transition leave-absolute>
              <span v-if="open"
                >hier kann zusätzliches CSS definiert werden</span
              >
            </v-fade-transition>
          </v-expansion-panel-header>
          <v-expansion-panel-content
            ><VCode
              content="&lt;style scoped&gt;
&lt;/style&gt;"
            ></VCode>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </Standardfolie>
  </NavigationComponent>
</template>

<script>
import NavigationComponent from "../components/NavigationComponent";
import Standardfolie from "../components/Standardfolie";
import VCode from "../components/VCode";
export default {
  name: "AppVue",
  components: { Standardfolie, NavigationComponent, VCode }
};
</script>

<style scoped></style>
